<script setup lang="ts">
import PeaceRequest from '@/components/Sections/News/Types/PeaceRequest.vue'
import NAPAccepted from '@/components/Sections/News/Types/NAPAccepted.vue'
import FriendAccepted from '@/components/Sections/News/Types/FriendAccepted.vue'
import FriendRejected from '@/components/Sections/News/Types/FriendRejected.vue'
import PeaceAccepted from '@/components/Sections/News/Types/PeaceAccepted.vue'
import FriendRequest from '@/components/Sections/News/Types/FriendRequest.vue'
import NAPRejected from '@/components/Sections/News/Types/NAPRejected.vue'
import BattleReport from '@/components/Sections/News/Types/BattleReport.vue'
import PlanetSettled from '@/components/Sections/News/Types/PlanetSettled.vue'
import PeaceRejected from '@/components/Sections/News/Types/PeaceRejected.vue'
import NAPExpired from '@/components/Sections/News/Types/NAPExpired.vue'
import TechAcquired from '@/components/Sections/News/Types/TechAcquired.vue'
import WarDeclared from '@/components/Sections/News/Types/WarDeclared.vue'
import NAPRequest from '@/components/Sections/News/Types/NAPRequest.vue'
import NewEmpireMet from '@/components/Sections/News/Types/NewEmpireMet.vue'
import type NewsItem from '@/types/NewsItem.ts'
import NewsShipsLostBlackHole from '@/components/Sections/News/Types/NewsShipsLostBlackHole.vue'
import FerionPlanetFound from '@/components/Sections/News/Types/FerionPlanetFound.vue'
import CreditBalancePenalty from '@/components/Sections/News/Types/CreditBalancePenalty.vue'
import SpyTrained from '@/components/Sections/News/Types/SpyTrained.vue'
import SpyKilled from '@/components/Sections/News/Types/SpyKilled.vue'
import SpyIntelligenceGatheringSuccess from '@/components/Sections/News/Types/SpyIntelligenceGatheringSuccess.vue'
import SpyAssassinateSuccess from '@/components/Sections/News/Types/SpyAssassinateSuccess.vue'
import SpyAssassinated from '@/components/Sections/News/Types/SpyAssassinated.vue'
import SpyDetected from '@/components/Sections/News/Types/SpyDetected.vue'
import SpyLevelUp from '@/components/Sections/News/Types/SpyLevelUp.vue'
import SpyCyberAttackSuccess from '@/components/Sections/News/Types/SpyCyberAttackSuccess.vue'
import SpyTechStolenSuccess from '@/components/Sections/News/Types/SpyTechStolenSuccess.vue'
import SpySabotageShipsSuccess from '@/components/Sections/News/Types/SpySabotageShipsSuccess.vue'
import SpyShipSabotaged from '@/components/Sections/News/Types/SpyShipSabotaged.vue'
import SpyTechStolen from '@/components/Sections/News/Types/SpyTechStolen.vue'

import PortalFound from '@/components/Sections/News/Types/PortalFound.vue'
import NewPrivateChat from './Types/NewPrivateChat.vue'
import RingworldCreated from '@/components/Sections/News/Types/RingworldCreated.vue'

withDefaults(
  defineProps<{
    newsItem: NewsItem
    toast?: boolean
  }>(),
  {
    toast: false
  }
)
</script>

<template>
  <span v-if="newsItem.type === 'new_empire_met'">
    <NewEmpireMet :newsItem="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'tech_acquired'">
    <TechAcquired :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'planet_settled'">
    <PlanetSettled :newsItem="newsItem" :toast="toast" />
  </span>

  <span v-else-if="newsItem.type === 'credit_balance_penalty'">
    <CreditBalancePenalty :newsItem="newsItem" :toast="toast" />
  </span>

  <span v-else-if="newsItem.type === 'battle_report'">
    <BattleReport :newsItem="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'war_declared'">
    <WarDeclared :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'friendship_request'">
    <FriendRequest :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'friendship_accepted'">
    <FriendAccepted :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'friendship_rejected'">
    <FriendRejected :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'peace_request'">
    <PeaceRequest :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'peace_accepted'">
    <PeaceAccepted :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'peace_rejected'">
    <PeaceRejected :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'nap_request'">
    <NAPRequest :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'nap_accepted'">
    <NAPAccepted :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'nap_rejected'">
    <NAPRejected :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'nap_expired'">
    <NAPExpired :news-item="newsItem" :toast="toast" />
  </span>

  <span v-else-if="newsItem.type === 'ships_lost_black_hole'">
    <NewsShipsLostBlackHole :newsItem="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'ferion_planet_found'">
    <FerionPlanetFound :newsItem="newsItem" :toast="toast" />
  </span>

  <!--- Spy ---->
  <span v-else-if="newsItem.type === 'spy_trained'">
    <SpyTrained :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_intelligence_gathering_success'">
    <SpyIntelligenceGatheringSuccess :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_assassinate_success'">
    <SpyAssassinateSuccess :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_assassinated'">
    <SpyAssassinated :news-item="newsItem" :toast="toast" />
  </span>

  <span v-else-if="newsItem.type === 'spy_killed'">
    <SpyKilled :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_detected'">
    <SpyDetected :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_level_up'">
    <SpyLevelUp :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_cyber_attack_success'">
    <SpyCyberAttackSuccess :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_tech_stolen_success'">
    <SpyTechStolenSuccess :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_tech_stolen'">
    <SpyTechStolen :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_sabotage_ships_success'">
    <SpySabotageShipsSuccess :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'spy_ship_sabotaged'">
    <SpyShipSabotaged :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'portal_found'">
    <PortalFound :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'new_private_chat'">
    <NewPrivateChat :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else-if="newsItem.type === 'ringworld_created'">
    <RingworldCreated :news-item="newsItem" :toast="toast" />
  </span>
  <span v-else>
    {{ newsItem }}
  </span>
</template>

<style scoped lang="scss"></style>
